import React from 'react';
import { Modal } from 'react-bootstrap';

import InsuranceStepIndicator from 'components/atoms/insurance_step_indicator';
import LegalBondNotice from 'components/atoms/legal_bond_notice';
import QuoteGuaranteeHeader from 'components/atoms/quote_guarantee_header';
import { DropZone, GuaranteeTypeItem } from 'components/atoms/bidding_quote_contract_upload/styles';
import HeaderConlicitaseg from 'components/organisms/header_conlicitaseg';
import { getInsuranceReasonOptions } from 'services/conlicitaseg';
import { getStepIndicatorProps } from 'services/conlicitaseg_flow';

import { Background, DarkBackdrop } from './styles';

const guaranteeOptions = getInsuranceReasonOptions();

const QuotePreview: React.FC = () => (
  <Background aria-hidden="true">
    <HeaderConlicitaseg offlineMode />
    <div className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-4">
          <div className="col-12 mx-auto">
            <div className="row align-items-stretch">
              <div className="col-md-9">
                <QuoteGuaranteeHeader title="Seguro Garantia" />

                <div className="shadow-sm p-4 bg-white rounded">
                  <h3 className="mb-4">Selecione o tipo de garantia</h3>
                  <div className="row">
                    {guaranteeOptions.map((option, idx) => (
                      <React.Fragment key={option.value}>
                        <div className="col-12 col-md-4 mb-3">
                          <GuaranteeTypeItem className="form-check px-5 py-3 border rounded bg-white h-100 mb-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              checked={false}
                              readOnly
                              tabIndex={-1}
                            />
                            <div className="form-check-label pl-2">{option.text}</div>
                          </GuaranteeTypeItem>
                        </div>
                        {idx === 0 && <div className="w-100" />}
                      </React.Fragment>
                    ))}
                  </div>

                  <h3 className="mt-4 mb-3">Upload do Contrato</h3>
                  <strong className="d-block mb-3">
                    Faça o upload do contrato para aprimorar as informações da sua cotação.
                  </strong>
                  <DropZone
                    as="div"
                    className="btn btn-block text-primary py-5 mb-2"
                    role="presentation"
                  >
                    <i className="material-icons align-middle mr-2">upload</i>
                    Clique para selecionar ou arraste os arquivos aqui
                  </DropZone>

                  <LegalBondNotice />

                  <div className="d-flex justify-content-end align-items-center mt-4">
                    <span className="btn btn-link mr-2">Continuar sem contrato</span>
                    <span className="btn btn-outline-primary">Cancelar cotação</span>
                    <span className="btn btn-primary ml-2">Continuar</span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 d-none d-md-block">
                <InsuranceStepIndicator
                  {...getStepIndicatorProps('dashboard_inactive', 'motivo', false, false)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Background>
);

const ConlicitasegSignupLayout: React.FC = ({ children }) => (
  <>
    <DarkBackdrop />
    <QuotePreview />

    <Modal
      show
      centered
      backdrop="static"
      keyboard={false}
      backdropClassName="conlicitaseg-signup-backdrop"
    >
      <Modal.Body className="p-4">{children}</Modal.Body>
    </Modal>
  </>
);

export default ConlicitasegSignupLayout;
